import React from 'react';
import PropTypes from 'prop-types';

function PhoneIcon({ color = 'black', width = 16, height = 16, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.53932 6.37733C6.12213 6.67522 5.99289 7.24441 6.29076 7.6616C6.85548 8.45255 7.54745 9.14452 8.3384 9.70924C8.75559 10.0071 9.32478 9.87787 9.62267 9.46068L9.835 9.16333C9.95346 8.99745 10.1286 8.88073 10.3273 8.83528C10.526 8.78982 10.7345 8.81878 10.9133 8.91667C12.0919 9.56077 13.3935 9.94815 14.7325 10.0533C14.9415 10.0699 15.1365 10.1646 15.2788 10.3186C15.421 10.4726 15.5 10.6745 15.5 10.8842V14.6025C15.5 14.8088 15.4235 15.0078 15.2853 15.161C15.1471 15.3142 14.9569 15.4106 14.7517 15.4317C14.31 15.4775 13.865 15.5 13.4167 15.5C6.28333 15.5 0.5 9.71667 0.5 2.58333C0.5 2.135 0.5225 1.69 0.568333 1.24833C0.589379 1.04308 0.68582 0.852934 0.838991 0.714695C0.992163 0.576456 1.19117 0.499956 1.3975 0.5H5.11583C5.32547 0.499974 5.52741 0.57896 5.6814 0.721209C5.83539 0.863458 5.93011 1.05852 5.94667 1.2675C6.05185 2.60649 6.43923 3.90807 7.08333 5.08667C7.18122 5.26547 7.21018 5.47395 7.16472 5.67266C7.11927 5.87137 7.00255 6.04654 6.83667 6.165L6.53932 6.37733ZM4.01163 7.06726C3.81463 6.65474 3.96367 6.16823 4.33568 5.90254L4.94933 5.46426C5.14497 5.32453 5.21233 5.06579 5.11942 4.84405C4.7602 3.98665 4.50916 3.08727 4.3725 2.16667H2.175C2.17 2.305 2.1675 2.44417 2.1675 2.58333C2.16667 8.79667 7.20333 13.8333 13.4167 13.8333C13.5558 13.8333 13.695 13.8308 13.8333 13.825V11.6275C12.9127 11.4908 12.0133 11.2398 11.1559 10.8806C10.9342 10.7877 10.6755 10.855 10.5357 11.0507L10.0975 11.6643C9.83177 12.0363 9.34526 12.1854 8.93274 11.9884C8.72595 11.8896 8.52242 11.784 8.3225 11.6717L8.27417 11.6442C6.63965 10.7139 5.28607 9.36035 4.35583 7.72583L4.32833 7.6775C4.21602 7.47758 4.1104 7.27405 4.01163 7.06726Z"
        fill={color}
      />
    </svg>
  );
}

PhoneIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default PhoneIcon;
